import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core'

import { SectionContentMedia } from 'app/core/cms/generated/api-types'
import { baseContainerMd } from 'app/static/style-vars.const'

import { CmsBlock } from '../../cms-block'
import { ContainerInfo } from '../../container-info'
import { InsertDynamicContentDirective } from '../../insert-dynamic-content.directive'
import { LayoutContainer } from '../layout-container'
import { parseDesign } from '../section-utils'

@Component({
  selector: 'pai-section-content-media',
  templateUrl: './section-content-media.component.html',
  styleUrls: ['./section-content-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.background]': 'design().background',
    '[attr.innerShadow]': 'design().innerShadow',
  },
  imports: [InsertDynamicContentDirective],
  providers: [
    { provide: CmsBlock, useExisting: SectionContentMediaComponent },
    { provide: LayoutContainer, useExisting: SectionContentMediaComponent },
  ],
})
export class SectionContentMediaComponent extends CmsBlock<SectionContentMedia> implements LayoutContainer {
  readonly __typename = 'SectionContentMedia'
  protected readonly design = computed(() => parseDesign(this.data().design))
  protected readonly content = computed(() => this.data().otherContent ?? [])
  protected readonly mediaItem = computed(() => this.data()?.media?.[0] ?? null)

  readonly containerInfo = signal<ContainerInfo>({
    maxWidthAtMd: '50vw', // fixme: but at sm it is 100vw as we no longer have 2 columns
    maxWidthAtLg: `${baseContainerMd / 2}px`,
    maxWidthAtXl: `${baseContainerMd / 2}px`, // lg ???
  })
}
